import React, {
  useState,
  createContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { useRouter } from "next/router";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import HsnPopup from "../hsn/hsn_dialog";
import { Dialog, Transition } from "@headlessui/react";
import Categorymenu from "@/layout/hsn_categorymenu";
import axios from "axios";
import { ENDPOINTS, WEB_URL } from "@/config/endpoints";
import { LineWave } from "react-loader-spinner";
import { Collapse } from "react-collapse";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

export default function HTSSearch() {
  const [open, setOpen] = useState(false);
  const [hsnCategories, setHsnCategories] = useState([]);
  const [hsnAllCategories, setHsnAllCategories] = useState([]);
  const [hsnSubCategories, setSubHsnCategories] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [APIData, setAPIData] = useState([]);
  const router = useRouter();
  const [show, setShow] = useState(false);
  const [showHsn, setShowHsn] = useState(false);
  const [showMainDropdown, setShowMainDropdown] = useState(true);
  const [showSearchDropdown, setshowSearchDropdown] = useState(true);
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const [accordionHSNOpen, setAccordionHSNOpen] = useState(false);
  const [selectedDesc, setSelectedDesc] = useState("HSN");
  const [open1, setOpen1] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const searchDropDownRef = useRef(null);
  const subCategoryDropDownRef = useRef(null);
  const [isLoadingAllCategories, setIsLoadingAllCategories] = useState(false);
  const [isLoadingSubCategories, setIsLoadingSubCategories] = useState(false);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [noDataFoundinSearch, setnoDataFoundinSearch] = useState(false);
  const [showhsnDetail, setshowhsnDetail] = useState(false);
  const [hoveredSection, setHoveredSection] = useState(null);

  useEffect(
    () => {
      const handleEsc = (event) => {
        if (event.keyCode === 27) {
          setshowSearchDropdown(false);
        }
      };

      window.addEventListener("keydown", handleEsc);
      function handleClickOutside(event) {
        if (
          searchDropDownRef.current &&
          !searchDropDownRef.current.contains(event.target)
        ) {
          setshowSearchDropdown(false);
        }

        if (
          subCategoryDropDownRef.current &&
          !subCategoryDropDownRef.current.contains(event.target)
        ) {
          setShowSubDropdown(false);
        }
      }
      // Bind the event listener

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("keydown", handleEsc);
      };
    },
    [searchDropDownRef],
    [subCategoryDropDownRef]
  );


  useEffect(() => {
    if (searchTerm.length >= 3) {
      fetchData(searchTerm);
      setnoDataFoundinSearch(false);
    } else{
      setshowSearchDropdown(false);
    }
  }, [searchTerm]);

  const showAllButtonClick = () => {
    setshowhsnDetail(false);
    setShowSubDropdown(false);
    getAllCategories();
    if (hsnAllCategories.length > 0) {
      const firstSection = hsnAllCategories[0];
      accordionHSNToggle(
        0,
        firstSection.section,
        `Section ${firstSection.section}`
      );
    }
    setOpen1(true);
  };

  const fetchData = async () => {
    setshowSearchDropdown(true);
    setIsLoadingSearch(true);
    setnoDataFoundinSearch(false);
  
    try {
      const response = await axios.get(
        `${ENDPOINTS.HTS_CODE_API}hts-by-keyword?keyword=${searchTerm}&start=0&size=10`,
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      const results = [];
      const search = searchTerm.toLowerCase();

      const mainDataMatches =
        (data.htsCode?.toLowerCase().includes(search) ||
          data.description?.toLowerCase().includes(search))
  
      if (mainDataMatches) {
        results.push(data);
      }
      setAPIData(data);
      setSearchInput(searchTerm);
      setIsLoadingSearch(false);
      setnoDataFoundinSearch(data.length === 0);
    } catch (err) {
      console.error("Search failed:", err);
      setIsLoadingSearch(false);
      setnoDataFoundinSearch(true);
    }
  };
  
  //function call on category hover end
  function showAllPhoneCategories() {
    setOpen1(true);
    getAllCategories();
  }
  //function all catetories dropdown start
  async function getCategories() {
    setIsLoadingAllCategories(true);
    setShowMainDropdown(true);
    setshowSearchDropdown(false);
    try {
      const response = await axios.get(
        `${ENDPOINTS.HTS_CODE_API}grouped-chapters?start=0&size=99`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (hsnCategories.length == 0) {
        setIsLoadingAllCategories(false);
      }
      setHsnCategories(response.data);
      setHsnAllCategories(response.data);
      setIsLoadingAllCategories(false);
    } catch (err) {}
  }

  const handleSubCategoryBox = () => {
    setShowSubDropdown(false);
  };
  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Async function to fetch subcategories
  const getSubCategory = useCallback(async () => {
    setIsLoadingSubCategories(true);

    try {
      const groupedChaptersResponse = await axios.get(
        `${ENDPOINTS.HTS_CODE_API}grouped-chapters?start=0&size=99`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const groupedChapters = groupedChaptersResponse.data || [];
      setSubHsnCategories(groupedChapters);
    } catch (err) {
      console.error("Failed to fetch grouped chapters:", err);
    } finally {
      setIsLoadingSubCategories(false);
    }
  }, []);

  // Debounced version of the async getSubCategory function
  const debouncedGetSubCategory = useCallback(debounce(getSubCategory, 500), [
    getSubCategory,
  ]);

  const handleMouseEnter = (id, desc) => {
    setHoveredSection(id);
    debouncedGetSubCategory(id, desc);
    setIsLoadingSubCategories(true);
    setShowSubDropdown(true);
  };

  const handleMouseLeave = () => {
    debouncedGetSubCategory.cancel();
    setShowSubDropdown(false);
    setIsLoadingSubCategories(false);
  };

  const handleOnCloseHsn = () => {
    setShowHsn(false);
  };

  //function on seel all categories in dropdown
  async function getAllCategories() {
    try {
      const response = await axios.get(
        `${ENDPOINTS.HTS_CODE_API}grouped-chapters?start=0&size=99`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setHsnAllCategories(response.data);
    } catch (err) {}
  }

  const accordionHSNToggle = (index, desc) => {
    setSelectedDesc(desc);
    if (accordionHSNOpen === index) {
      return setAccordionHSNOpen(null);
    }
    setAccordionHSNOpen(index);
  };

  function highlightText(text = "", highlight = "") {
    if (!text) return null;
    if (!highlight) return text;
    const escapedHighlight = highlight.replace(/[*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="bg-yellow-300 font-bold">
          {part}
        </span>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  }

  return (
    <>
      <section
        className={[
          "relative sm:z-[10] ",
          router.pathname == "/hts-code"
            ? "py-12 md:py-6"
            : "py-16 sm:pt-24 sm:py-16",
        ].join(" ")}
      >
         <Image
          priority
          src={IMAGES.ImportFactoring.ImportBGBanner.src}
          width={1366}
          height={550}
          className="absolute inset-0 max-w-none w-full h-full -z-[1]"
          alt="Banner Desktop"
        />
        <div className="max-w-[1100px] mx-auto xm:px-2 sm:px-2">
          {router.pathname == "/hts-code" ? (<>
              <h1 className="font-medium text-center mb-1">
              <span className="block text-xxl sm:text-lg text-[#FFFFFF] sm:mb-xsp">
                HTS Code Lookup
              </span>
              <span className="block text-headingbold sm:mb-xsp font-medium sm:text-xxl text-[#FFFFFF] md:text-heading5">
                Find Tariff Codes by Product or Number
              </span>
            </h1>
            <h2 className="text-base sm:text-sm text-[#FFFFFF] mb-5 sm:mb-3 md:text-lg text-center">Search the Harmonized Tariff Schedule by entering a product name or HTS code to get duty rates, descriptions, and classification details.</h2>
            </> ) : (<>
            <div className="text-center">
              <p className="block text-xxl sm:text-lg text-[#FFFFFF] sm:mb-xsp font-medium">
                HTS Code Lookup
              </p>
              <p className="block text-headingbold mb-1 sm:mb-xsp font-medium sm:text-xxl text-[#FFFFFF] md:text-heading5">
                Find Tariff Codes by Product or Number
              </p>
            <p className="text-base sm:text-sm text-[#FFFFFF] mb-5 sm:mb-3 md:text-lg text-center">Search the Harmonized Tariff Schedule by entering a product name or HTS code to get duty rates, descriptions, and classification details.</p>
            </div>
            </>)}
          <div className="sm:w-full w-[800px] md:w-full m-auto relative">
            <div className="flex items-start justify-between md:justify-center relative z-[51]">
              <div className="sm:w-[15%] md:w-[10%]">
                <Menu as="div" className="inline-block text-left">
                  <div>
                    <Menu.Button
                      onClick={getCategories}
                      className="inline-flex md:hidden sm:hidden sm:w-full w-[177px] justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50"
                    >
                      <span>All Categories</span>                        
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"></path></svg>
                    </Menu.Button>
                    <div className="hidden sm:block md:block justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white sm:px-xsp sm:py-xsp md:py-xsp px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 sm:h-[50px] sm:w-[100%]">
                      <div className="flex items-center">
                        <span className="sr-only">Open main menu</span>
                        <svg 
                           onClick={showAllPhoneCategories}
                           xmlns="http://www.w3.org/2000/svg" 
                           viewBox="0 0 24 24" 
                           width="36" 
                           height="36" 
                           fill="currentColor" 
                           className="block h-6 w-6 sm:w-full sm:h-6"
                           aria-hidden="true">
                           <path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path>
                         </svg>
                      </div>
                    </div>
                  </div>
                  <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
                    <Transition.Root show={open1} as={Fragment}>
                      <Dialog
                        as="div"
                        className="relative z-[100]"
                        onClose={setOpen}
                      >
                        <div className="fixed inset-0" />

                        <div className="fixed inset-0 overflow-hidden">
                          <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-14">
                              <Transition.Child
                                as={Fragment}
                                enter="transform transition origin-left ease-in-out duration-300 sm:duration-300"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-300 sm:duration-300"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                              >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                                  <div className="flex h-full flex-col overflow-y-scroll bg-white">
                                    <button
                                      type="button"
                                      className="rounded-md left-[-45px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2 sm:left-1 sm:top-0 sm:z-[99999]"
                                      onClick={() => setOpen1(false)}
                                    >
                                      <span className="sr-only">
                                        Close panel
                                      </span>
                                      <XMarkIcon
                                        className="h-6 w-6 text-white"
                                        aria-hidden="true"
                                      />
                                    </button>
                                    <div className="relative px-0">
                                      <div className="sm:pt-3">
                                        <div className="mt-3 text-center sm:mt-0">
                                          <section className="bg-white">
                                            <div className="container px-3 xm:px-2">
                                              <div className="bg-white sm:w-auto text-left  lg:m-auto">
                                                <div className="mx-auto  sm:w-auto">
                                                  {hsnAllCategories?.map(
                                                    (sectionData, index) => {
                                                      return (
                                                        <div
                                                          className="border border-bordercolor overflow-hidden rounded-lg mb-2"
                                                          key={
                                                            sectionData.section
                                                          }
                                                        >
                                                          {/* Accordion Header */}
                                                          <div
                                                            className="bg-[#EFF5FA] p-2 flex justify-between items-center cursor-pointer"
                                                            onClick={() =>
                                                              accordionHSNToggle(
                                                                index,
                                                                sectionData.section,
                                                                `Section ${sectionData.section}`
                                                              )
                                                            }
                                                          >
                                                            <p className="text-base text-secondary font-medium">
                                                              Section{" "}
                                                              {
                                                                sectionData.section
                                                              }
                                                            </p>
                                                            <div>
                                                              {index ===
                                                              accordionHSNOpen ? (
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 24 24"
                                                                  width="24"
                                                                  height="24"
                                                                >
                                                                  <path d="M11.9997 10.8284L7.04996 15.7782L5.63574 14.364L11.9997 8L18.3637 14.364L16.9495 15.7782L11.9997 10.8284Z"></path>
                                                                </svg>
                                                              ) : (
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 24 24"
                                                                  width="24"
                                                                  height="24"
                                                                >
                                                                  <path d="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z"></path>
                                                                </svg>
                                                              )}
                                                            </div>
                                                          </div>

                                                          {/* Accordion Content */}
                                                          <Collapse
                                                            isOpened={
                                                              index ===
                                                              accordionHSNOpen
                                                            }
                                                          >
                                                            {sectionData.chapters.map(
                                                              (chapter) => {
                                                                const chapterLink = `${WEB_URL}/hts-code/chapter/${chapter.chapter}`;
                                                                return (
                                                                  <Link
                                                                    key={
                                                                      chapter.chapter
                                                                    }
                                                                    href={
                                                                      chapterLink
                                                                    }
                                                                    rel="noopener noreferrer"
                                                                  >
                                                                    <div
                                                                      className="bg-white text-base text-[#4B93EE] p-1 cursor-pointer"
                                                                      onClick={() => {
                                                                        setOpen1(
                                                                          false
                                                                        ); // Optional — if you are managing open/close state elsewhere
                                                                      }}
                                                                    >
                                                                      <div className="flex">
                                                                        <span className="mr-2">
                                                                          {parseInt(
                                                                            chapter.chapter,
                                                                            10
                                                                          )}
                                                                        </span>
                                                                        <span>
                                                                          {
                                                                            chapter.description
                                                                          }
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                  </Link>
                                                                );
                                                              }
                                                            )}
                                                          </Collapse>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </section>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                    </Transition.Root>
                  </HideCategoryMenuContext.Provider>
                  {showMainDropdown && (
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        className={`absolute pointer-events-auto left-[0px] z-10 mt-2 w-[223px] min-h-[260px] origin-top-right  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                          showSubDropdown ? "rounded-s-lg" : "rounded-md"
                        }`}
                      >
                        <>
                          <div className="py-1">
                            <Menu.Item>
                              <ul>
                                {isLoadingAllCategories && (
                                  <li className="text-brand font-medium flex justify-center">
                                    <LineWave
                                      height="100"
                                      width="100"
                                      color="#022b5c"
                                      middleLineColor="#e3a200"
                                      lastLineColor="#022b5c"
                                    />
                                  </li>
                                )}

                                {hsnCategories
                                  .slice(0, 5)
                                  .map((sectionData) => (
                                    <li
                                      key={sectionData.section}
                                      aria-expanded={
                                        showSubDropdown ? "true" : "false"
                                      }
                                      onMouseOver={() =>
                                        handleMouseEnter(
                                          sectionData.section,
                                          `Section ${sectionData.section}`
                                        )
                                      }
                                      onMouseOut={handleMouseLeave}
                                      onClick={() => setShowSubDropdown(false)}
                                      className="text-brand font-medium cursor-pointer"
                                    >
                                      <div className="relative">
                                        <div className="flex items-center justify-between text-sm p-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                                          <span className="inline-block max-w-[80%]">
                                            Section {sectionData.section}
                                          </span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="w-[15px] h-[15px]"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M8.25 4.5l7.5 7.5-7.5 7.5"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                <li
                                  className="text-brand font-medium"
                                  onClick={showAllButtonClick}
                                >
                                  <div
                                    className="relative"
                                    onClick={() => setOpen1(true)}
                                  >
                                    <div className="flex items-center relative justify-between text-sm p-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]  cursor-pointer">
                                      Show all
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Menu.Item>
                          </div>
                        </>
                      </Menu.Items>
                    </Transition>
                  )}
                </Menu>
                <div
                  onMouseOver={() => setShowSubDropdown(true)}
                  className={`absolute top-[55px]  left-[213px] z-10  h-[260px] min-h-[260px]  w-[595px] max-w-[595px] transform px-1 sm:px-0 ${
                    showSubDropdown ? "block" : "hidden"
                  }`}
                >
                  <div
                    ref={subCategoryDropDownRef}
                    className="overflow-hidden h-full shadow-lg ring-1 ring-black ring-opacity-5"
                    onClick={handleSubCategoryBox}
                  >
                    <div className="relative grid bg-white py-1 h-full">
                      <ul className="overflow-auto h-full">
                        {isLoadingSubCategories && (
                          <li className="flex cursor-pointer justify-center text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                            <LineWave
                              height="100"
                              width="100"
                              color="#022b5c"
                              middleLineColor="#e3a200"
                              lastLineColor="#022b5c"
                            />
                          </li>
                        )}

                        {!isLoadingSubCategories && (
                          <>
                            {hsnSubCategories
                              .filter(
                                (sectionData) =>
                                  sectionData.section === hoveredSection
                              )
                              .map((sectionData) => {
                                return (
                                  <div key={sectionData.section}>
                                    <ul className="mb-4">
                                      {sectionData.chapters.map((chapter) => {
                                        return (
                                          <Link
                                            key={chapter.chapter}
                                            href={`${WEB_URL}/hts-code/chapter/${chapter.chapter}`}
                                            rel="noopener noreferrer"
                                          >
                                            <li className="flex cursor-pointer text-sm rounded-md p-1 m-1 transition duration-150 ease-in-out hover:text-brand hover:bg-[#EFF5FA]">
                                              <span className="text-anchor-blue mr-2 min-w-[80px]">
                                                Chapter{" "}
                                                {parseInt(chapter.chapter, 10)}
                                              </span>
                                              <span className="text-gray-800">
                                                {chapter.description}
                                              </span>
                                            </li>
                                          </Link>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                );
                              })}
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sm:w-[84%] w-[85%] sm:ml-[1%] ml-[20px]">
                <div className="relative flex items-start">
                  <input
                    value={searchTerm}
                    onChange={handleInputChange}
                    type="text"
                    name="search"
                    id="search"
                    autoComplete="off"
                    placeholder="Enter HTS Code or product description"
                    className="inline-flex w-[606px] sm:w-full tex-sm sm:h-[50px] md:h-[50px] md:w-[100%]  md:ml-0 lg:justify-between items-center gap-x-1.5 text-[#5F5F5F] rounded-[10px] bg-white px-3 py-1 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none"
                  /> 
                  <div className="absolute inset-y-0 right-0 flex py-1.5 pr-1.5 bg-white rounded-r-[10px] mt-0.5">
                  <div className="inline-flex items-center px-1 font-sans text-xs text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="currentColor"
                    >
                      <path d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"></path>
                    </svg>
                  </div>
                </div>
                </div>
              </div>
            </div>

            {showSearchDropdown && (
              <>
                {searchInput.length >= 2 ? (
                  <div
                    ref={searchDropDownRef}
                    className="bg-white drop-shadow z-[50] absolute lg:top-2 max-h-[325px] overflow-auto searchDrodownMobileLeft lg:pt-[32px] lg:ml-[197px] lg:w-[599px] tex-sm sm:h-auto md:w-[85%] sm:w-[83%] md:ml-0 sm:left-[17%] md:left-[15%]"
                  >
                    {noDataFoundinSearch && (
                      <li className="text-brand font-medium flex justify-center py-1">
                        NO DATA FOUND
                      </li>
                    )}

                    {isLoadingSearch && (
                      <li className="text-brand font-medium flex justify-center">
                        <LineWave
                          height="100"
                          width="100"
                          color="#022b5c"
                          middleLineColor="#e3a200"
                          lastLineColor="#022b5c"
                        />
                      </li>
                    )}
                    {APIData.map((result) => {
                      return (
                        <>
                          <Link href={WEB_URL + `/hts-code/${String(result.htsCode).replace(/\./g, "")}`}>
                            <div
                              onClick={() => {
                                setshowSearchDropdown(false);
                              }}
                              className="w-full cursor-pointer p-1 flex border-b border-[#00000020]"
                              key={result.htsCode}
                            >
                              <span className="mr-2 text-[12px] h-3 text-white w-[25px] font-medium rounded-sm bg-[#022b5c] p-[3px] flex items-center justify-center">
                                {" "}
                                {result.chapter}
                              </span>
                              <span className="pr-2 text-[14px]">
                                {result.description
                                  ? highlightText(
                                      result.description,
                                      searchInput
                                    )
                                  : null}
                                {result.htsCode != null && (
                                  <span>
                                    {" "}
                                    (
                                    {result.htsCode
                                      ? highlightText(
                                          result.htsCode,
                                          searchInput
                                        )
                                      : null}
                                    )
                                  </span>
                                )}
                              </span>
                            </div>
                          </Link>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </div>
      </section>

      <HsnPopup
        onClose={handleOnCloseHsn}
        show={showHsn}
        setShowHsn={(bool) => setShow(bool)}
      />

      {/* /* hsn finder input end */}
      <HideCategoryMenuContext.Provider value={{ open, setOpen }}>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
            <div className="fixed inset-0" />
            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden bg-[rgba(0,0,0,0.7)] z-[12]">
                <div className=" fixed inset-y-0 right-0 flex max-w-full pl-14">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-500"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md z-[12]">
                      <div className="flex h-full flex-col overflow-y-scroll bg-white pt-2 pb-6 shadow-xl">
                        <button
                          type="button"
                          className="rounded-md left-[-40px] top-1 text-gray-400 hover:text-gray-500 focus:outline-none absolute right-2"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon
                            className="h-6 w-6 text-white"
                            aria-hidden="true"
                          />
                        </button>
                        <div className="relative px-0">
                          {/* Replace with your content */}
                          <Categorymenu open={open} />
                          {/* /End replace */}
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </HideCategoryMenuContext.Provider>
      <HsnPopup
        onClose={handleOnCloseHsn}
        show={showHsn}
        setShowHsn={(bool) => setShow(bool)}
      />
    </>
  );
}

// Debounce function definition for async functions
function debounce(func, delay) {
  let timeoutId;
  const debouncedFunction = function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };

  debouncedFunction.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  return debouncedFunction;
}

export const HideCategoryMenuContext = createContext();
